import { Bot } from "lucide-react";
import { useTranslation } from "react-i18next";

export function AgentBadge() {
  const { t } = useTranslation();
  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full bg-indigo-100 dark:bg-indigo-900 text-indigo-700 dark:text-indigo-300 whitespace-nowrap">
      <Bot className="h-3 w-3" />
      {t("agent.badge")}
    </span>
  );
}
